module.exports = __webpack_public_path__ + "static/media/fly0113.4052d60b.webp";